import axios from 'axios'
import cookie from 'cookie'
import gtagV4 from './google-analytics-v4'
import { mobileCheck } from './helpers'

const delay = mobileCheck() ? 750 : 500
const form = document.querySelector('#sse-form')
const input = document.querySelector('#sse-input')
const autocomplete = document.querySelector('#sse-autocomplete')
const completerWord = document.querySelector('#sse-completer')
const suggestionsList = document.querySelector('#sse-suggestions')
const resultsList = document.querySelector('#sse-results')

let timer = ''
let lastSearch = ''

input.addEventListener('focus', () => {
  if (lastSearch && lastSearch == input.value) {
    autocomplete.classList.add('sse-show')
  }
})

input.addEventListener('keyup', (e) => {
  clearTimeout(timer)

  timer = setTimeout(() => {
    const { value } = input
    const { keyCode } = e

    if (value.length < 3) {
      autocompleteClose()
      return
    }

    if (isValidKey(keyCode)) search(value)
  }, delay)
})

document.addEventListener('click', (e) => {
  const isOpen = document.querySelector('#sse-autocomplete.sse-show')

  if (
    isOpen &&
    e.target != input &&
    e.target != autocomplete &&
    e.target != suggestionsList &&
    e.target != resultsList
  ) {
    autocomplete.classList.remove('sse-show')
  }
})

//load event
track('load')

/**
 * Check if is valid key code
 *
 * @param  int keyCode Keycode
 * @return bool
 */
function isValidKey(keyCode) {
  return (keyCode >= 41 && keyCode <= 222) || [8, 229].indexOf(keyCode) > -1
}

/**
 * Close autocomplete
 *
 * @return void
 */
function autocompleteClose() {
  suggestionsList.innerHTML = 'Non ci sono dati da mostrare'
  resultsList.innerHTML = ''
  completerWord.innerHTML = ''
}

/**
 * Search
 *
 * @param  string q Query
 * @return void
 */
function search(q) {
  lastSearch = q
  form.classList.add('sse-searching')
  // input.disabled = true

  axios
    .get('https://sse.dogma-dynamics.com/1.0.0/', {
      params: { q },
      headers: {
        'X-Api-Key': 'italiavr',
      },
    })
    .then(({ data }) => {
      const { suggestions, results, completer } = data
      suggest(suggestions, results, completer)

      track('search', { q })
    })
    .catch((e) => console.log(e))
    .finally(() => {
      form.classList.remove('sse-searching')
      // input.disabled = false
      input.focus()
    })
}

/**
 * Apply suggestion
 *
 * @param  array suggestions
 * @param  array results
 */
function suggest(suggestions = [], results = [], completer = '') {
  if (!suggestions.length && !results.length) {
    autocompleteClose()
    return
  }

  completerWord.innerHTML = completer

  if (suggestions.length) {
    suggestionsList.innerHTML = ''
    suggestions.forEach((item) => {
      const node = document.createElement('a')
      node.setAttribute('href', '#')
      node.classList.add(item.class)
      node.text = item.word

      node.addEventListener('click', (e) => {
        e.preventDefault()
        input.value = node.text
        search(node.text)

        track('select', { v: node.text, c: node.className })
      })

      suggestionsList.append(node)
    })
  }

  if (results.length) {
    resultsList.innerHTML = ''

    results.forEach((item) => {
      const node = document.createElement('a')
      node.setAttribute('href', item.link)
      node.innerHTML = `<span>${item.title}<q>${item.text}</q></span>`

      const figure = document.createElement('figure')
      if (item.image) {
        figure.style.backgroundImage = `url('${item.image}')`
      }
      node.prepend(figure)

      resultsList.append(node)
    })
  }

  autocomplete.classList.add('sse-show')
}

/**
 * Registra l'evento su analytics
 * @see https://developers.google.com/analytics/devguides/collection/gtagjs/events
 *
 * @return void
 * @param string action Azione evento
 * @param object value Oggetto da serializzare e alvare nel Label
 */
function track(action, value = {}) {
  //no analytics installed
  if (typeof gtag == 'undefined') {
    console.info('No google analytics gtag finded')
    return
  }
  //unix time
  const t = Math.floor(new Date().getTime() / 1000)
  //page
  const p =
    document.location.pathname +
    document.location.search +
    document.location.hash
  //user session
  const s = cookie.parse(document.cookie)['user_session']
  //v4 tracking
  gtagV4(`sse_${action}`, { s, p, t, ...value })
}
